import moment from 'moment-timezone';
import get from 'lodash/get';

import * as actions from 'actions/temporaryAbsence';

export const defaultState = {
  start: moment().startOf('day'),
  end: moment().startOf('day').add(1, 'days'),
  groups: [],
  error: '',
  orgConfig: {},
  orgConfigLoading: false,
  dialogError: {},
  isGlobalAbsence: true,
  replacement: {},
  isDialogOpen: false,
  isSaving: false,
  includeDirectNotifications: true,
};

const isSelected = group => group.selected;

const defaultUserStartAndEnd = user =>
  user && user.timezone
    ? {
        start: moment().tz(user.timezone).startOf('day'),
        end: moment().tz(user.timezone).startOf('day').add(1, 'days'),
      }
    : {};

const makeError = payload => payload.json || { messageId: 'ERROR' };

export default function temporaryAbsence(state = defaultState, action) {
  const { payload } = action;
  switch (action.type) {
    case actions.SET_TEMP_ABSENCE_START:
      return {
        ...state,
        start: action.payload,
      };
    case actions.SET_TEMP_ABSENCE_END:
      return {
        ...state,
        end: action.payload,
      };
    case actions.SET_INCLUDE_DIRECT_NOTIFICATIONS:
      return {
        ...state,
        includeDirectNotifications: action.payload,
      };
    case actions.SET_TEMP_ABSENCE_USER_DETAILS: {
      const user = action.payload;
      return {
        ...state,
        ...user,
        ...defaultUserStartAndEnd(user),
      };
    }
    case actions.SET_TEMP_ABSENCE_DIALOG_OPEN:
      return { ...state, isDialogOpen: action.payload };
    case actions.GET_USER_GROUPS_SUCCESS: {
      // make sure that we are only looking at those groups where the membership
      // is based on PERSON recipient
      let groups = [...action.payload.data]
        .filter(
          membership => get(membership, 'member.recipientType') === 'PERSON',
        )
        .map(membership => get(membership, 'group'));

      if (state.isGlobalAbsence) {
        groups = groups.map(group => ({
          ...group,
          selected: true,
        }));
      }

      return {
        ...state,
        groups,
      };
    }
    case actions.GET_ORGANIZATION_CONFIG_SUCCESS: {
      const orgConfig = action.payload;
      return {
        ...state,
        orgConfig,
        orgConfigLoading: false,
      };
    }
    case actions.GET_ORGANIZATION_CONFIG_START: {
      return {
        ...state,
        orgConfigLoading: true,
      };
    }
    case actions.TEMP_ABSENCE_GROUP_TOGGLE: {
      const updatedGroups = state.groups.map(group => {
        if (group.id === action.payload) {
          return {
            ...group,
            selected: !group.selected,
          };
        }
        return group;
      });

      return {
        ...state,
        groups: updatedGroups,
        isGlobalAbsence: updatedGroups.every(isSelected),
      };
    }
    case actions.TEMP_ABSENCE_ALL_GROUP_CHANGE: {
      const { isGlobalAbsence } = state;
      if (isGlobalAbsence && state.groups.length === 0) {
        return {
          ...state,
          isGlobalAbsence: !isGlobalAbsence,
        };
      }

      return {
        ...state,
        isGlobalAbsence: !isGlobalAbsence,
        groups: state.groups.map(group => ({
          ...group,
          selected: !isGlobalAbsence,
        })),
      };
    }
    case actions.TEMP_ABSENCE_RESET_STATE:
      return {
        ...state,
        ...defaultState,
        ...defaultUserStartAndEnd(state),
      };
    case actions.GET_USER_GROUPS_FAIL:
    case actions.TEMP_ABSENCE_SAVE_FAIL:
      return {
        ...state,
        isSaving: false,
        dialogError: makeError(payload),
      };
    case actions.GET_ORGANIZATION_CONFIG_FAIL: {
      return {
        ...state,
        orgConfigLoading: false,
        dialogError: makeError(payload),
      };
    }

    case actions.TEMP_ABSENCE_SAVE_SUCCESS:
    case actions.TEMP_ABSENCE_SAVE_START:
      return {
        ...state,
        isSaving: true,
      };
    case actions.SET_TEMP_ABSENCE_REPLACEMENT:
      return {
        ...state,
        replacement: action.payload,
      };
    default:
      return state;
  }
}
